import PropTypes from "prop-types"
import Icon from "components/planning_center_icon"

const AttendeeAssignments = ({ attendee, event }) => {
  return (
    <div className="line p-2 registration-details">
      <h4 className="mb-2 fw-600">Assignments</h4>
      <ul className="unstyled mb-0">
        {event.assignmentTypes.map(at => {
          const assignment = attendee.assignments.find(a => a.assignmentTypeId === at.id)
          return (
            <li key={at.id}>
              {assignment && (
                <>
                  <strong>{at.name}:&nbsp;</strong>
                  {assignment.areaName}
                  <Icon symbol="general#check" style={{ top: 1 }} className="icon c-success ml-1" />
                </>
              )}
              {!assignment && (
                <>
                  <strong>{at.name}:&nbsp;</strong>
                  <span>Unassigned</span>
                </>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

AttendeeAssignments.propTypes = {
  attendee: PropTypes.shape({
    assignments: PropTypes.array
  }),
  event: PropTypes.shape({
    assignmentTypes: PropTypes.array
  })
}

export default AttendeeAssignments
